import { ReactNode } from 'react';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

interface IProps {
  icon: ReactNode;
  text?: string | ReactNode;
  onClick: () => void;
  divider?: boolean;
  padding?: string;
}

export const PopUpItem = ({ icon, text, onClick, divider, padding }: IProps) => {
  return (
    <MenuItem id="pop-up-item-component__components-menu-burger__menuitem__l14"
    sx={{ padding: padding ? padding : 2, width: '180px' }}
    aria-label="Home"
    onClick={onClick}
    divider={divider}>
      
      <ListItemIcon id="pop-up-item-component__components-menu-burger__listitemicon__l20">{icon}</ListItemIcon>
      {text && <ListItemText id="pop-up-item-component__components-menu-burger__listitemtext__l21">{text}</ListItemText>}
    </MenuItem>);

};